import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouteSelectionComponent } from './components/route-selection/route-selection.component';
import { MapComponent } from './components/map/map.component';
import { SystemStatusComponent } from './components/system-status/system-status.component';
import { NtaComponent } from './components/nta/nta.component';
import { TrainviewComponent } from './components/trainview/trainview.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ScheduleRoutesComponent } from './components/schedule-routes/schedule-routes.component';
import { SchedulesComponent } from './components/schedules/schedules.component';
import { ScheduleRouteDetailsComponent } from './components/schedule-route-details/schedule-route-details.component';
import { ScheduleTimetableComponent } from './components/schedule-timetable/schedule-timetable.component';
import { RouteStatusComponent } from './components/route-status/route-status.component';
import { TripDetailComponent } from './components/trip-detail/trip-detail.component';
import { StopComponent } from './components/stop/stop.component';
import { StopDetailsComponent } from './components/stop-details/stop-details.component';
import { TripSchedulesComponent } from './components/trip-schedules/trip-schedules.component';
import { FourOhFourComponent } from './components/four-oh-four/four-oh-four.component';


const routes: Routes = [
  {path: '', component: DashboardComponent},
  {path: 'dashboard', component: DashboardComponent},
  {path: 'routes', component: RouteSelectionComponent},
  {path: 'routes/status', component: RouteStatusComponent},
  {path: 'routes/status/:route', component: RouteStatusComponent},
  {path: 'system', component: SystemStatusComponent},
  {path: 'system/:mode', component: SystemStatusComponent},
  {path: 'train', component: TrainviewComponent},
  {path: 'map', component: MapComponent},
  {path: 'trip/detail', component: TripDetailComponent},
  {path: 'trip/detail/:block', component: TripDetailComponent},
  {path: 'nta', component: NtaComponent},
  {path: 'schedules-old', component: ScheduleRoutesComponent},
  {path: 'schedules', component: SchedulesComponent},
  {path: 'schedules/:route', component: ScheduleRouteDetailsComponent},
  {path: 'schedules/:route/:direction', component: ScheduleRouteDetailsComponent},
  {path: 'schedules/:route/:direction/:stop', component: ScheduleRouteDetailsComponent},
  {path: 'schedule/trip/:trip', component: TripSchedulesComponent},
  {path: 'schedule/timetable/:route', component: ScheduleTimetableComponent},
  {path: 'schedule/timetable/:route/:direction', component: ScheduleTimetableComponent},
  {path: 'schedule/timetable/:route/:direction/:date', component: ScheduleTimetableComponent},
  {path: 'stop/:stop', component: StopDetailsComponent},
  {path: 'stop/:mode/:stop/:id', component: StopComponent},
  {path: 'systemstatus', component: SystemStatusComponent},
  {path: 'bus_trolley/:id', component: RouteStatusComponent},
  {path: 'bus_trolley', component: MapComponent},
  {path: 'regionalrail', component: TrainviewComponent},
  {path: '**', component: FourOhFourComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
